"use client";

import { useSearchParams } from "next/navigation";

/**
 * Returns true when the site is rendered inside the CRM preview iframe
 * (?mode=preview&slug=<themeSlug>). Use this to disable actions that
 * should not be triggered during theme previews (e.g. placing orders).
 *
 * useSearchParams() requires a Suspense boundary to work correctly in
 * Next.js App Router. Wrap any component using this hook (or its parent)
 * in <Suspense> so params are available on the first client render.
 */
export function useIsPreviewMode(): boolean {
  const searchParams = useSearchParams();
  return searchParams.get("mode") === "preview" && !!searchParams.get("slug");
}
